import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import Topbar from "../topBar";
import Sidebar from "../sideBar";
import axios from "axios";
import Cookies from "universal-cookie";
import url1 from "./urlPage";
import { Editor } from "@tinymce/tinymce-react";
import  Swal  from "sweetalert2/dist/sweetalert2";
import { ERR_GETTING } from "../../constants/alertMessage";
import { privateApiCall } from "../../api/privateApi";

const cookies = new Cookies();

export default class edit_product extends Component {
  componentDidMount() {
    
  const jwtToken = cookies.get("jwtToken");
  privateApiCall(
    "/editproduct/" +
    this.props.match.params._id +
    "/?token=" +
    cookies.get("asia_page_token"),'GET')
   
      .then(
        (res) => {
          this.setState({ name: res.data.product[0].name });
          this.setState({ category_id: res.data.product[0].category_id });

          this.setState({ description: res.data.product[0].description });
          this.setState({ image1: res.data.product[0].image1 });
          this.setState({ image2: res.data.product[0].image2 });
          this.setState({ image3: res.data.product[0].image3 });
          this.setState({ image4: res.data.product[0].image4 });
          this.setState({ image5: res.data.product[0].image5 });
        },
        (err) => {
          Swal.fire({
            title: `${ERR_GETTING}`,
            icon: "error",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonText: "OK",
          });
        }
      );
   privateApiCall( "/addcategory/?token=" + cookies.get("asia_page_token"),'GET')
      .then(
        (res) => {
          const k = 1;

          for (let i = 0; i < res.data.length; i++) {
            res.data[i].sno = k + +i;
          }

          this.setState({ data: res.data });
        },
        (err) => {
          Swal.fire({
            title: `${ERR_GETTING}`,
            icon: "error",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonText: "OK",
          });
        }
      );
  }

  constructor() {
    super();
    window.postMessage("renderTable", "*");

    this.state = {
      name: "",
      // video: "",
      category_id: "",
      //subcategory_id:"",
      data: [],
      data1: [],
      data2: [],
      data3: [],

      image1: "http://placehold.it/60/c2c2c2?text=User",
      image2: "http://placehold.it/60/c2c2c2?text=User",
      image3: "http://placehold.it/60/c2c2c2?text=User",
      image4: "http://placehold.it/60/c2c2c2?text=User",
      image5: "http://placehold.it/60/c2c2c2?text=User",
      description: "",
    };

    this.handlenameChange = this.handlenameChange.bind(this);

    // this.subcategory = this.subcategory.bind(this);
    this.changeimage1 = this.changeimage1.bind(this);
    // var changevideo = this.chanchangevideogeimage2;
    // this.changevideo = this.changevideo.bind(this);
    this.changeimage2 = this.changeimage2.bind(this);
    this.changeimage3 = this.changeimage3.bind(this);
    this.changeimage4 = this.changeimage4.bind(this);
    this.changeimage5 = this.changeimage5.bind(this);
    this.description = this.description.bind(this);
  }

  changeimage1(event) {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.setState({ image1: e.target.result });
      };
      reader.readAsDataURL(event.target.files[0]);
    } else {
      this.setState({ image1: "http://placehold.it/60/c2c2c2?text=User" });
    }
  }
  changeimage2(event) {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.setState({ image2: e.target.result });
      };
      reader.readAsDataURL(event.target.files[0]);
    } else {
      this.setState({ image2: "http://placehold.it/60/c2c2c2?text=User" });
    }
  }
  changeimage3(event) {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.setState({ image3: e.target.result });
      };
      reader.readAsDataURL(event.target.files[0]);
    } else {
      this.setState({ image3: "http://placehold.it/60/c2c2c2?text=User" });
    }
  }
  changeimage4(event) {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.setState({ image4: e.target.result });
      };
      reader.readAsDataURL(event.target.files[0]);
    } else {
      this.setState({ image4: "http://placehold.it/60/c2c2c2?text=User" });
    }
  }
  changeimage5(event) {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.setState({ image5: e.target.result });
      };
      reader.readAsDataURL(event.target.files[0]);
    } else {
      this.setState({ image5: "http://placehold.it/60/c2c2c2?text=User" });
    }
  }

  handlenameChange(event) {
    this.setState({ name: event.target.value });
  }
  category(event) {
    this.setState({ category_id: event.target.value });
    privateApiCall("/listsubcatgeory/" +
    event.target.value +
    "/?token=" +
    cookies.get("asia_page_token"),'GET')
   
      .then(
        (res) => {
          this.setState({ data1: res.data.data });
        },
        (err) => {
          console.log(err);
        }
      );
  }

  description(event) {
    this.setState({ description: event });
  }

  render() {
    return (
      <div>
        <Topbar backgroundColor="#769A0F" />
        <Sidebar />
        <div className="content-page">
          <div className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box">
                    <h4 className="page-title float-left">Edit product</h4>

                    <ol className="breadcrumb float-right">
                      <li className="breadcrumb-item">
                        {" "}
                        <NavLink to="/dashboard">Dashboard</NavLink>
                      </li>
                      <li className="breadcrumb-item">
                        {" "}
                        <NavLink to="/product">products</NavLink>
                      </li>
                      <li className="breadcrumb-item active">Edit product</li>
                    </ol>

                    <div className="clearfix"></div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="card-box">
                    <form
                     
                      method="post"
                      enctype="multipart/form-data"
                      action={
                        "/editproduct/" +
                        this.props.match.params._id +
                        "/?token=" +
                        cookies.get("asia_page_token")
                      }
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <h4 className="m-t-0 m-b-30 header-title"></h4>

                          <div className="form-group">
                            <label>Product Name</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter name"
                              name="name"
                              value={this.state.name}
                              onChange={this.handlenameChange}
                              required
                            />
                          </div>

                          <div className="form-group">
                            <label>Category</label>
                            <select
                              id="single"
                              className="form-control"
                              value={this.state.category_id}
                              name="category_id"
                              required
                              //  id="sel1"
                              onChange={this.category}
                            >
                              <option value="">Select Category</option>
                              {this.state.data.map((person, i) => (
                                <option key={i} value={person._id}>
                                  {" "}
                                  {person.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="form-group">
                            <label>
                              {" "}
                              <span className="label-text">
                                Product description
                              </span>
                            </label>
                            <input
                              type="hidden"
                              name="description"
                              value={this.state.description}
                            ></input>
                            <Editor
                              initialValue={this.state.description}
                              init={{
                                plugins: [
                                  "advlist autolink link lists charmap print preview hr anchor pagebreak spellchecker",
                                  "searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime nonbreaking",
                                  "save table contextmenu directionality emoticons template paste textcolor",
                                ],
                                toolbar:
                                  "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link | print preview fullpage | forecolor backcolor emoticons",
                              }}
                              onEditorChange={this.description}
                              apiKey="uxjmfte1hqpg5tmlpjt5sllltuxcz4q4899bcxa9uzgbd98d"
                              cloudChannel="dev"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <h4 className="m-t-0 m-b-30 header-title"></h4>
                          <div className="form-group">
                            <label>Product Image </label>
                            <div className="row">
                              <div className="col-md-4">
                                <div className="form-group">
                                  <div
                                    className="col-12"
                                    style={{ paddingBottom: "11px" }}
                                  >
                                    {this.state.image1 != "" &&
                                    this.state.image1 != null ? (
                                      <img
                                        className="img-responsive"
                                        src={this.state.image1}
                                        alt="user"
                                        style={{
                                          width: "150px",
                                          height: "150px",
                                        }}
                                      />
                                    ) : (
                                      <img
                                        className="img-responsive"
                                        src="http://placehold.it/60/c2c2c2?text=User"
                                        alt="user"
                                        style={{
                                          width: "150px",
                                          height: "150px",
                                        }}
                                      />
                                    )}
                                    <br />
                                    <input
                                      type="hidden"
                                      className="default"
                                      value={this.state.image1}
                                      name="image1"
                                      onChange={this.changeimage1}
                                      id="upload_file"
                                      accept="image/*"
                                    />
                                    <input
                                      type="file"
                                      className="default"
                                      name="image1"
                                      onChange={this.changeimage1}
                                      id="upload_file"
                                      accept="image/*"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-4">
                                <div className="form-group">
                                  <div
                                    className="col-12"
                                    style={{ paddingBottom: "11px" }}
                                  >
                                    {this.state.image2 != "" &&
                                    this.state.image2 != null ? (
                                      <img
                                        className="img-responsive"
                                        src={this.state.image2}
                                        alt="user"
                                        style={{
                                          width: "150px",
                                          height: "150px",
                                        }}
                                      />
                                    ) : (
                                      <img
                                        className="img-responsive"
                                        src="http://placehold.it/60/c2c2c2?text=User"
                                        alt="user"
                                        style={{
                                          width: "150px",
                                          height: "150px",
                                        }}
                                      />
                                    )}
                                    <br />
                                    <input
                                      type="hidden"
                                      className="default"
                                      value={this.state.image2}
                                      name="image2"
                                      onChange={this.changeimage2}
                                      id="upload_file"
                                      accept="image/*"
                                    />
                                    <input
                                      type="file"
                                      className="default"
                                      name="image2"
                                      onChange={this.changeimage2}
                                      id="upload_file"
                                      accept="image/*"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-4">
                                <div className="form-group">
                                  <div
                                    className="col-12"
                                    style={{ paddingBottom: "11px" }}
                                  >
                                    {this.state.image3 != "" &&
                                    this.state.image3 != null ? (
                                      <img
                                        className="img-responsive"
                                        src={this.state.image3}
                                        alt="user"
                                        style={{
                                          width: "150px",
                                          height: "150px",
                                        }}
                                      />
                                    ) : (
                                      <img
                                        className="img-responsive"
                                        src="http://placehold.it/60/c2c2c2?text=User"
                                        alt="user"
                                        style={{
                                          width: "150px",
                                          height: "150px",
                                        }}
                                      />
                                    )}
                                    <br />
                                    <input
                                      type="hidden"
                                      className="default"
                                      value={this.state.image3}
                                      name="image3"
                                      onChange={this.changeimage3}
                                      id="upload_file"
                                      accept="image/*"
                                    />
                                    <input
                                      type="file"
                                      className="default"
                                      name="image3"
                                      onChange={this.changeimage3}
                                      id="upload_file"
                                      accept="image/*"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-4">
                              <div className="form-group">
                                <div
                                  className="col-12"
                                  style={{ paddingBottom: "11px" }}
                                >
                                  {this.state.image4 != "" &&
                                  this.state.image4 != null ? (
                                    <img
                                      className="img-responsive"
                                      src={this.state.image4}
                                      alt="user"
                                      style={{
                                        width: "150px",
                                        height: "150px",
                                      }}
                                    />
                                  ) : (
                                    <img
                                      className="img-responsive"
                                      src="http://placehold.it/60/c2c2c2?text=User"
                                      alt="user"
                                      style={{
                                        width: "150px",
                                        height: "150px",
                                      }}
                                    />
                                  )}
                                  <br />
                                  <input
                                    type="hidden"
                                    className="default"
                                    value={this.state.image4}
                                    name="image4"
                                    onChange={this.changeimage4}
                                    id="upload_file"
                                    accept="image/*"
                                  />
                                  <input
                                    type="file"
                                    className="default"
                                    name="image4"
                                    onChange={this.changeimage4}
                                    id="upload_file"
                                    accept="image/*"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <div
                                  className="col-12"
                                  style={{ paddingBottom: "11px" }}
                                >
                                  {this.state.image5 != "" &&
                                  this.state.image5 != null ? (
                                    <img
                                      className="img-responsive"
                                      src={this.state.image5}
                                      alt="user"
                                      style={{
                                        width: "150px",
                                        height: "150px",
                                      }}
                                    />
                                  ) : (
                                    <img
                                      className="img-responsive"
                                      src="http://placehold.it/60/c2c2c2?text=User"
                                      alt="user"
                                      style={{
                                        width: "150px",
                                        height: "150px",
                                      }}
                                    />
                                  )}
                                  <br />
                                  <input
                                    type="hidden"
                                    className="default"
                                    value={this.state.image5}
                                    name="image5"
                                    onChange={this.changeimage5}
                                    id="upload_file"
                                    accept="image/*"
                                  />
                                  <input
                                    type="file"
                                    className="default"
                                    name="image5"
                                    onChange={this.changeimage5}
                                    id="upload_file"
                                    accept="image/*"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="form-group col-md-6">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          style={{ float: "left", backgroundColor: "#11abff" }}
                        >
                          Submit
                        </button>
               
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
